import { client } from './client';
import type { Company, LoginResponse, User, AdminSignupResponse, InviteValidationResponse } from '../../types';

export const api = {
  login: async (email: string, password: string) => {
    try {
      const response = await client.post<LoginResponse>('/auth/login', { email, password });
      return response;
    } catch (error) {
      throw new Error('Invalid email or password');
    }
  },

  getMe: async () => {
    try {
      const response = await client.get<{ user: User }>('/auth/me', { requiresAuth: true });
      return response;
    } catch (error) {
      throw new Error('Failed to fetch user data');
    }
  },

  validateInvite: async (token: string) => {
    try {
      const response = await client.get<InviteValidationResponse>(`/invites/validate/${token}`);
      return response;
    } catch (error) {
      throw new Error('Invalid or expired invite link');
    }
  },

  signupAdmin: async (data: {
    email: string;
    password: string;
    firstName: string;
    lastName: string;
    token: string;
  }) => {
    try {
      const response = await client.post<AdminSignupResponse>('/auth/signup-admin', data);
      return response;
    } catch (error) {
      throw new Error('Failed to create admin account');
    }
  },

  getCompanies: async () => {
    try {
      const response = await client.get<{ success: boolean; companies: Company[] }>(
        '/companies',
        { requiresAuth: true }
      );
      return response.companies;
    } catch (error) {
      throw new Error('Failed to fetch companies');
    }
  },

  createCompany: async (data: {
    name: string;
    domain: string;
    logoUrl?: string;
  }) => {
    try {
      const response = await client.post<{ success: boolean; company: Company }>(
        '/companies',
        data,
        { requiresAuth: true }
      );
      return response;
    } catch (error) {
      throw new Error('Failed to create company');
    }
  },

  createCompanyInvite: async (data: {
    email: string;
    role: string;
    companyId: string;
  }) => {
    try {
      const response = await client.post<{
        success: boolean;
        invite: {
          id: string;
          email: string;
          inviteUrl: string;
        };
      }>(
        '/invites/company',
        data,
        { requiresAuth: true }
      );
      return response;
    } catch (error) {
      throw new Error('Failed to create company invite');
    }
  }
};